import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { Box } from '../Box';
import { createComponent } from '../utils';
export var Flex = createComponent({
    name: 'Flex',
    as: Box,
    style: function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))); },
});
Flex.displayName = 'Flex';
var templateObject_1;
//# sourceMappingURL=Flex.js.map